import { SelectFilterOperationType } from 'module/types/filter-field/filter/select';
import { FormattedMessage } from 'react-intl';

export const selectTriggerOptionRenderers = (
  operationType: SelectFilterOperationType,
): null | React.JSX.Element => {
  switch (operationType) {
    case SelectFilterOperationType.Is: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is" />
      );
    }

    case SelectFilterOperationType.IsNot: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_not" />
      );
    }

    case SelectFilterOperationType.IsOneOf: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_one_of" />
      );
    }

    case SelectFilterOperationType.IsNoneOf: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_none_of" />
      );
    }

    case SelectFilterOperationType.IsEmpty: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_empty" />
      );
    }

    case SelectFilterOperationType.IsNotEmpty: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_not_empty" />
      );
    }

    default: {
      return null;
    }
  }
};
